/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";

const CarouselImage = (props) => {

    const image = props?.image;
    const settings = props?.settings;
    const isHomepage = props?.isHomepage;
    const src = image?.src;
    const alt = image?.alt;
    let position = "center center";
    const options = settings?.options;
    const format = settings?.format;
    if (format === "image.format.cropped-focus") {
        position = options?.position;
    }
    const csstype = isHomepage ? "home-banner-image" : "carousel-image";

    if (image) {
        return (
            <div
                className={csstype}
                title={alt}
                style={{
                    backgroundImage: `url(${src})`,
                    backgroundSize: "cover",
                    backgroundPosition: `${position}`,
                    objectFit: "contain",
                }}
            />
        );
    } else {
        return (
            <div className='carousel-loading'>
                <div className='loader'>
                    {/*Loading image...*/}
                </div>
            </div>
        );
    }
};

CarouselImage.displayName = "CarouselImage";
export { CarouselImage };
